import { render, staticRenderFns } from "./ForumUser.vue?vue&type=template&id=609fcdcc&scoped=true&"
import script from "./ForumUser.vue?vue&type=script&lang=js&"
export * from "./ForumUser.vue?vue&type=script&lang=js&"
import style0 from "./ForumUser.vue?vue&type=style&index=0&id=609fcdcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fcdcc",
  null
  
)

export default component.exports